import { Checkbox } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const uncheckedStyle = {
  display: "inline-block",
  width: 20,
  height: 20,
  borderRadius: "50%",
  border: "2px solid #ccc",
  backgroundColor: "#fff",
};

const checkedStyle = {
  backgroundColor: "#1976d2",
  borderColor: "#1976d2",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

interface RoundCheckboxProps {
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}

const RoundCheckbox = ({ checked, disabled, onChange }: RoundCheckboxProps) => {
  return (
    <Checkbox
      sx={{ padding: 0 }}
      checked={checked}
      icon={<span style={uncheckedStyle} />}
      checkedIcon={
        <span style={{ ...uncheckedStyle, ...checkedStyle }}>
          <CheckIcon style={{ fontSize: 16, color: "#fff" }} />
        </span>
      }
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default RoundCheckbox;
